import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../shared/services/customer.service';
import { Subscription } from 'rxjs';
import { CustomerModel } from '../shared/models/customer-model';
import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-view',
  templateUrl: './customer-view.component.html',
  styleUrls: ['./customer-view.component.less'],
  standalone: false,
})
export class CustomerViewComponent implements OnInit, OnDestroy {
  private customerId: number;

  public customer: CustomerModel;

  private sub: Subscription;

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  public onUpdate(success: boolean) {
    this.refresh();
  }

  private refresh(customerId: any = null) {
    if (!customerId) customerId = this.customer.customerId;
    this.customerService
      .getCustomer(customerId)
      .subscribe((d) => (this.customer = d));
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((p) => {
      let customerId = +p['id'];
      this.customerId = customerId;
      this.refresh(customerId);
    });
  }
}
